export default "__VITE_ASSET__DzIvQrQC__"